import "./App.css";
import Layout from "./components/layouts/Layout";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Home from "./pages/Home/Home";
import AboutUs from "./pages/AboutUs/AboutUs";
import Career from "./pages/Career/Career";
import ContactUs from "./pages/ContactUs/ContactUs";
import PrivacyPolicy from "./pages/Privacypolicy/PrivacyPolicy";
import ReturnPolicy from "./pages/Return Policy/ReturnPolicy";
import ShippingPolicy from "./pages/ShippingPolicy/ShippingPolicy";
import TermsaAndConditions from "./pages/TermsaAndConditions/TermsaAndConditions";
import Delivery from "./pages/Delivery/Delivery";
import Disclaimer from "./pages/Disclaimer/Disclaimer";
import JobDescription from "./pages/JobDescription/JobDescription";
import Ecard from "./pages/Ecard/Ecard";
import {
  Ecard_Atul,
  Ecard_Mukesh,
  Ecard_Rahul,
  Ecard_Sajal,
  Ecard_Siddhant,
  Ecard_Vikas,
  Ecard_atul,
  Ecard_img,
} from "./helper/imageConstant";
// import Faqs from "./pages/Faqs/Faqs";

function App() {
  return (
    <>
      <div>
        <Router>
          <Routes>
            <Route exact path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route exact path="/about-us" element={<AboutUs />} />
              <Route exact path="/Careers" element={<Career />} />
              <Route exact path="/contact-us" element={<ContactUs />} />
              <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route exact path="/return-policy" element={<ReturnPolicy />} />
              <Route
                exact
                path="/shipping-policy"
                element={<ShippingPolicy />}
              />
              <Route
                path="/terms-and-conditions"
                element={<TermsaAndConditions />}
              />
              <Route path="/delivery" element={<Delivery />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/job-description" element={<JobDescription />} />
              {/* <Route path="/faqs" element={<Faqs />} /> */}
            </Route>
            <Route
              path="/vaibhavjain"
              element={
                <Ecard
                  phoneNumber={"917575020200"}
                  image={Ecard_img}
                  name={"vaibhav jain"}
                  number={"+91 75750 20200"}
                />
              }
            />
            <Route
              path="/atuljain"
              element={
                <Ecard
                  phoneNumber={"918905678961"}
                  image={Ecard_Atul}
                  name={"atul jain"}
                  number={"+91 89056 78961"}
                />
              }
            />
            <Route
              path="/siddhantjain"
              element={
                <Ecard
                  phoneNumber={"919099107104"}
                  image={Ecard_Siddhant}
                  name={"siddhant jain"}
                  number={"+91 90991 07104"}
                />
              }
            />
            <Route
              path="/vikasjain"
              element={
                <Ecard
                  phoneNumber={"919377483141"}
                  image={Ecard_Vikas}
                  name={"vikas jain"}
                  number={"+91 93774 83141"}
                />
              }
            />
            <Route
              path="/rahuljain"
              element={
                <Ecard
                  phoneNumber={"919909048470"}
                  image={Ecard_Rahul}
                  name={"rahul jain"}
                  number={"+91 99090 48470"}
                />
              }
            />
            <Route
              path="/mukeshbhutra"
              element={
                <Ecard
                  phoneNumber={"919909037413"}
                  image={Ecard_Mukesh}
                  name={"mukesh bhutra"}
                  number={"+91 99090 37413"}
                />
              }
            />
            <Route
              path="/sajalraghuvanshi"
              element={
                <Ecard
                  phoneNumber={"919512857570"}
                  image={Ecard_Sajal}
                  name={"sajal raghuvanshi"}
                  number={"+91 95128 57570"}
                />
              }
            />
          </Routes>
        </Router>
      </div>
    </>
  );
}

export default App;
